import * as React from "react";
import { IconBase, IIconBase } from "src/icons/IconBase";

export const AutomationIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Automation</title>
    <path d="M35.89,21.42H31L29.12,17.2,31,13h4.89l1.49,1.9,3.15-2.47L37.84,9H28.4l-2.66,6H16.38l-.06.23L16,16.3l-.14.52L13.07,27h-4l1,4h0l2.07,8H7v4H36.59l-1-4H22.83l-2.31-8.94h0l3-10.87h2.12l2.77,6.22h9.44L40.53,22l-3.15-2.47ZM18.1,39H16.35l-2.07-8h2.35l2.07,8ZM29,17.21h0Z" />
  </IconBase>
);
